import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const DesktopADSR = dynamic(() => import("../../components/software-partners/ADSR/DesktopADSR"), {
    loading: () => <Loading />,
});

const MobileADSR = dynamic(() => import("../../components/software-partners/ADSR/MobileADSR"), {
    loading: () => <Loading />,
});

const adsrIntegration = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>Automated Daily Sales Report: ADSR Integration with POS</title>
                <meta name="description" content="Integrate QueueBuster POS with ADSR Software for efficient mall management. Enhance operations, streamline tasks, and boost overall mall performance." />
                <link rel="canonical" href="https://queuebuster.co/pos-software-partners/adsr" />
                <link rel="alternate" href="https://queuebuster.co/pos-software-partners/adsr" hrefLang="en-us" />
                <meta property="og:title" content="Automated Daily Sales Report: Optimize Mall Management with POS and ADSR Integration" />
                <meta property="og:description" content="Enhance your mall management operations with QueueBuster POS integration with ADSR Software. Streamline tasks, improve efficiency, and boost performance with our seamless solution. Experience better control and management for your mall operations." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/adsr.jpg" />
                <meta property="og:url" content="https://queuebuster.co/pos-software-partners/adsr" />
            </Head>
            {mobileView ? <MobileADSR /> : <DesktopADSR />}
        </>
    )
}

export default adsrIntegration